'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;

var _lodash = require('lodash.isobject');

var _lodash2 = _interopRequireDefault(_lodash);

var _isArray = require('./isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if the value is an Object
 *
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is an Object
 */
function isObject(param) {
  return (0, _lodash2.default)(param) && !(0, _isArray2.default)(param);
}
//# sourceMappingURL=isObject.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isObject.js
 ** module id = 17
 ** module chunks = 0 1
 **/